import React from "react";

const AppML_Forms = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Forms</h1>
      <p>This is the AppML Forms page content.</p>
    </div>
  );
};

export default AppML_Forms;
